export var ErroredSkuStatus;
(function (ErroredSkuStatus) {
    ErroredSkuStatus["NEW"] = "new";
    ErroredSkuStatus["RESOLVED"] = "resolved";
})(ErroredSkuStatus || (ErroredSkuStatus = {}));
//# sourceMappingURL=errored-sku.js.map